import { DialogHeading } from '@ariakit/react/dialog';
import cn from 'classnames';
import { CloseButton } from '#components/atoms/buttons/icon/CloseButton.tsx';
import { useModal } from '../modal/ModalContext.tsx';
import styles from './ModalHeader.module.css';

type Props = {
  children?: React.ReactNode;
};

export function ModalHeader({ children }: Props) {
  const { closeModal } = useModal();

  return (
    <header className={cn(styles.ModalHeader, { [styles.ModalHeader___bordered]: children })}>
      <DialogHeading className="h4 mw-0 m-0">{children}</DialogHeading>
      <CloseButton size={16} onClick={closeModal} />
    </header>
  );
}
